import { Outlet, useNavigate } from "react-router-dom";
import HashInterceptor from "../../components/HashInterceptor";
import Header from "../../components/Header";
import SelfHostHeader from "../../components/selfhost/SelfHostHeader";
import ROUTES from "../../routes.config";
import Footer from "../../components/Footer";

export default function SelfHostApp({}) {
  const navigate = useNavigate();

  return (
    <>
      <HashInterceptor />
      
    </>
  );
}
